// extracted by mini-css-extract-plugin
export default {"root":"AuDMnK","mobile":"clouFV","mediaWrapper":"GkUWPe","media":"XBH3oy"};